import { Spin } from 'antd';

const Loader = () => (
    <div className="page-loader">
        <Spin size="large" />
    </div>
);
export default Loader;
